import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

import {
  formatCurrency,
  formatDate,
} from '#common/utils';
import EnhancedTable, { EnhancedTableData, EnhancedTableHeader } from '#components/EnhancedTable';

interface UserAdditionalChangesProps {
  additionalCharges: EnhancedTableData;
}

export default function UserAdditionalChanges(props: UserAdditionalChangesProps) {
  const { additionalCharges } = props;
  const { t } = useTranslation('order');

  if (!additionalCharges.rows.length) {
    return null;
  }

  const headers: EnhancedTableHeader[] = [{
    id: 'name',
    label: t('additionalCharges.name'),
  }, {
    id: 'createdDate',
    label: t('additionalCharges.createdDate'),
    renderer: (row) => (row.createdDate
      ? formatDate(row.createdDate as string | number | Date)
      : t('additionalCharges.na')),
  }, {
    id: 'price',
    label: t('additionalCharges.amount'),
    renderer: (o) => `${formatCurrency(o.price as number)}`,
  }];

  return (
    <Box sx={{ mb: 5 }}>
      <EnhancedTable
        name="additional-charges"
        headers={headers}
        {...additionalCharges}
      />
    </Box>
  );
}
